/**
 * Register vue and vuex components
 * @requires Vue vuejs
 * @requires Vuex state management
 */
import Vue from "vue";
import Vuex from "vuex";
import campaign from './modules/campaign'
import products from './modules/products'
import packages from './modules/packages'
import donations from './modules/donate'
import updates from './modules/update_details'
import loyalty from './modules/loyalty'

Vue.use(Vuex);

/**
 * Register firebase sdk
 * @requires firebase initialises firebase
 */
import firebase from '../firebase';
Vue.use(firebase);


const store = new Vuex.Store({
  strict: false,
  //plugins: [createPersistedState({ storage: window.sessionStorage })],
  modules: {
    campaign,
    product : products,
    packages,
    donation: donations,
    updates,
    loyalty
  }
});

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js